<div class="bg-gray mt-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 d-none d-lg-block">
        <div
          class="project-banner h-100 text-center text-lg-left bg-white"
          [style]="
            'background-image: url(' +
            (project.banner
              ? project.banner
              : profile.banner
              ? profile.banner
              : './assets/img/constructoras/banner-constructora-1.jpg') +
            ')'
          "
        >
          <div class="project-logo pt-5 pl-3 pt-lg-3 d-none d-lg-block">
            <img
              [src]="
                project.logo
                  ? project.logo
                  : profile.image
                  ? profile.image
                  : 'assets/img/constructoras/logo-default.png'
              "
              alt=""
              class="img-fluid aspect-ratio-1 object-fit-contain bg-white rounded-3 p-1"
              style="max-height: 90px"
              width="90px"
            />
          </div>

          <div
            *ngIf="project.amount"
            class="bg-red text-white lh-1 py-2 pl-2 pr-4 position-absolute rounded-left d-none d-lg-block mb-3"
            style="right: 0; bottom: 0; width: fit-content"
          >
            Desde:
            <h5 class="mb-0 font-weight-bold">
              ${{ project.amount | number }}
            </h5>
          </div>
        </div>
      </div>
      <div
        class="col-lg-4"
        id="project-info"
        [style]="
          bgBanner(
            project.banner
              ? project.banner
              : profile.banner
              ? profile.banner
              : './assets/img/constructoras/banner-constructora-1.jpg'
          )
        "
      >
        <div class="py-5 my-lg-5 font-italic text-center" *ngIf="!project.title">
          ...Cargando información, <br> por favor espere un momento...
        </div>
        <div class="py-3" *ngIf="project.title">
          <div class="row mb-1 mb-lg-2">
            <div class="col-lg-7 d-none d-lg-block">
              <div>
                <h2 class="font-weight-bold mb-0 lh-1">{{ project.title }}</h2>
                <h6 class="font-weight-normal mb-0 small font-italic">
                  {{ profile.name }}
                </h6>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="d-flex align-items-end" id="shareBtns">
                <div class="dropdown">
                  <button
                    type="button"
                    class="btn text-red"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <!-- Compartir -->
                    <i class="fas fa-share-alt"></i>
                  </button>
                  <div class="dropdown-menu shadow border-0 rounded-3 px-3">
                    <div class="row text-center">
                      <div class="col-3 px-2">
                        <a
                          class="d-block text-secondary"
                          title="Compartir en Facebook"
                          target="_blank"
                          href="https://www.facebook.com/share.php?u={{
                            generateUri()
                          }}"
                        >
                          <h4 class="mb-0">
                            <i class="fab fa-facebook"></i>
                          </h4>
                        </a>
                      </div>
                      <div class="col-3 px-2">
                        <a
                          class="d-block text-secondary"
                          title="Compartir en Twitter"
                          target="_blank"
                          href="https://twitter.com/share?url={{
                            generateUri()
                          }}&via=vivienda.com"
                        >
                          <h4 class="mb-0">
                            <i class="fab fa-twitter"></i>
                          </h4>
                        </a>
                      </div>
                      <div class="col-3 px-2">
                        <a
                          class="d-block text-secondary"
                          title="Compartir en WhatsApp"
                          target="_blank"
                          href="https://wa.me/?text=Hola, encontré este inmueble en la página vivienda.com {{
                            generateUri()
                          }}{{
                            project.zone
                              ? project.city
                                ? ', Ubicado en ' +
                                  project.zone +
                                  ', ' +
                                  project.city
                                : ', Ubicado en ' + project.zone
                              : ''
                          }}"
                        >
                          <h4 class="mb-0">
                            <i class="fab fa-whatsapp"></i>
                          </h4>
                        </a>
                      </div>
                      <div class="col-3 px-2">
                        <a
                          class="d-block text-secondary"
                          title="Compartir el enlace"
                          (click)="copyLink()"
                          href="javascript:void(0)"
                        >
                          <h4 class="mb-0">
                            <i class="far fa-copy"></i>
                          </h4>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <a href="javascript:void(0)" class="btn text-red text-center">
                  <i class="far fa-file-pdf"></i>
                </a>
                <a href="javascript:void(0)" class="btn text-red text-center">
                  <i class="far fa-heart"></i>
                </a>
                <a href="javascript:void(0)" class="btn text-red text-center">
                  <i class="fas fa-exclamation-circle"></i>
                </a>
              </div>
            </div>
          </div>

          <!-- logo mobile -->
          <div class="project-logo my-3 d-lg-none text-center">
            <img
              [src]="
                project.logo
                  ? project.logo
                  : profile.image
                  ? profile.image
                  : 'assets/img/constructoras/logo-default.png'
              "
              alt=""
              class="img-fluid aspect-ratio-1 object-fit-contain bg-white rounded-3"
              style="max-height: 90px"
            />
          </div>

          <!-- description -->
          <div class="row mb-1 mb-lg-2">
            <div class="col-auto pr-0 d-none d-lg-block">
              <i class="fas fa-city"></i>
            </div>
            <div class="col">
              <div class="description lh-1 rounded-3 p-3 p-lg-0">
                {{ project.description }}
              </div>
            </div>
          </div>

          <div class="row mb-1 mb-lg-2">
            <div class="col-auto pr-0 d-none d-lg-block">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div class="col">
              <div class="salaventas rounded-3 px-3 py-2 px-lg-0 py-lg-0">
                <b> Sala de Ventas:</b><br class="d-lg-none" />{{
                  project.address
                }}
              </div>
            </div>
          </div>

          <!-- teléfono -->
          <div class="row mb-1 mb-lg-2 d-none d-lg-flex" *ngIf="project.phones?.phone">
            <div class="col-auto pr-0">
              <i class="fas fa-mobile-alt"></i>
            </div>
            <div class="col">
              <div class="d-inline-block d-lg-block mr-3 mr-lg-0">
                <a
                  href="tel:{{ project.phones.phone}}"
                  class="text-blue"
                >
                  {{ project.phones?.phone }}
                </a>
              </div>
            </div>
          </div>

          <!-- email -->
          <div class="row mb-1 mb-lg-2 d-none d-lg-flex" *ngIf="project.phones?.email">
            <div class="col-auto pr-0">
              <i class="fas fa-envelope"></i>
            </div>
            <div class="col">
              <div class="d-inline-block d-lg-block mr-3 mr-lg-0">
                <a
                  href="mailto:{{ project.phones.email }}"
                  class="text-blue"
                  target="_blank"
                >
                  {{ project.phones.email }}
                </a>
              </div>
            </div>
          </div>

          <!-- sitio web -->
          <div class="row mb-1 mb-lg-2 d-none d-lg-flex" *ngIf="project.phones?.website">
            <div class="col-auto pr-0">
              <i class="fas fa-globe"></i>
            </div>
            <div class="col">
              <div class="d-inline-block d-lg-block mr-3 mr-lg-0">
                <a
                  href="//{{ project.phones.website }}"
                  class="text-blue"
                  target="_blank"
                >
                  {{ project.phones.website }}
                </a>
              </div>
            </div>
          </div>         

          <div class="d-none d-lg-flex gap-1 align-items-center">
            <h6 class="font-weight-normal mb-0">Contactános</h6>
            <a
              *ngIf="project.phones?.phone"
              href="tel:{{ project.phones.phone }}"
              class="btn px-2 py-1 shadow-sm bg-white text-secondary"
            >
              <i class="fas fa-phone-alt"></i>
            </a>
            <a
              *ngIf="project.phones?.whatsapp"
              href="//wa.me/57{{ project.phones.whatsapp }}"
              class="btn px-2 py-1 shadow-sm bg-white text-success"
              target="_blank"
            >
              <i class="fab fa-whatsapp"></i>
            </a>
            <a
              *ngIf="project.phones?.email"
              href="mailto:{{ project.email }}"
              class="btn px-2 py-1 shadow-sm bg-white text-secondary"
            >
              <i class="far fa-envelope"></i>
            </a>

            <a
              href="https://www.waze.com/es/live-map/directions?to=ll.{{
                project.latitude
              }}%2C{{ project.longitude }}"
              class="btn px-2 py-1 shadow-sm bg-white text-secondary"
              target="_blank"
              *ngIf="project.latitude && project.longitude"
            >
              <i class="fab fa-waze"></i>
            </a>

            <a
              href="https://www.google.com/maps/dir//{{ project.latitude }},{{
                project.longitude
              }}/"
              class="btn px-2 py-1 shadow-sm bg-white text-secondary"
              target="_blank"
              *ngIf="project.latitude && project.longitude"
            >
              <img
                src="./assets/img/googlemaps.png"
                alt=""
                width="18"
                height="18"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div
          class="py-2 h-100 flex-column"
          id="contactForm"
          [class]="openContact ? '' : 'd-none d-lg-block'"
        >
          <div class="card border-0 custom-shadow rounded-3 p-2">
            <button
              (click)="openContact = false"
              class="btn btn-red ml-auto d-lg-none"
            >
              <i class="fas fa-times"></i>
            </button>
            <form
              class="form-horizontal contactForm"
              #fContactWeb="ngForm"
              (ngSubmit)="contact(fContactWeb)"
            >
              <div class="form-group mb-2">
                <h5 class="text-red font-weight-bold mb-0">
                  Recibe Más Información
                </h5>
                <p class="font-weight-normal small mb-0">
                  Déjanos tus datos, pronto estaremos en contacto contigo.
                </p>
              </div>

              <div class="row">
                <div class="col-lg-6 pr-lg-1">
                  <div class="form-group mb-2">
                    <div class="font-weight-bold small">Nombre</div>
                    <input
                      type="text"
                      class="form-control w-100 h-auto m-0 py-0"
                      required
                      ngModel
                      name="name"
                    />
                  </div>
                </div>
                <div class="col-lg-6 pl-lg-1">
                  <div class="form-group mb-2">
                    <div class="font-weight-bold small">Apellido</div>
                    <input
                      type="text"
                      class="form-control w-100 h-auto m-0 py-0"
                      required
                      ngModel
                      name="surname"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 pr-lg-1">
                  <div class="form-group mb-2">
                    <div class="font-weight-bold small">Correo electrónico*</div>
                    <input
                      type="text"
                      class="form-control w-100 h-auto m-0 py-0"
                      required
                      ngModel
                      name="email"
                    />
                  </div>
                </div>
                <div class="col-lg-6 pl-lg-1">
                  <div class="form-group mb-2">
                    <div class="font-weight-bold small">Celular*</div>
                    <input
                      type="text"
                      class="form-control w-100 h-auto m-0 py-0"
                      required
                      ngModel
                      name="phone"
                    />
                  </div>
                </div>
              </div>
              
              <div class="form-group mb-2">
                <div class="font-weight-bold small">
                  Compra de vivienda para*
                </div>
                <select
                  class="form-control btn-rounded w-100 h-auto m-0 py-1"
                  required
                  name="message"
                  ngModel
                >
                  <option value="">Seleccionar...</option>
                  <option value="living">Vivienda</option>
                  <option value="reselling">Reventa</option>
                  <option value="leasing">Arrendamiento</option>
                </select>
              </div>
              <div class="form-group mb-0">
                <div class="form-check small">
                  <label
                    class="form-check-label text-red position-relative small lh-1"
                    for="terms"
                    style="left: 1%"
                    ><small>Acepto los términos y condiciones; autorizo tratamiento de
                    datos personales*</small></label
                  >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="terms"
                    required
                    checked
                    ngModel
                  />
                  <label
                    class="form-check-label"
                    for="terms"
                    style="left: 5px; top: 5px"
                  ></label>
                </div>
              </div>
              <div class="form-group mb-0 btn-reca">
                <div class="g-recaptcha recaptcha-1 col-12 text-center">
                  <re-captcha
                    #captchaRef="reCaptcha"
                    (resolved)="resolved($event)"
                    siteKey="6LdkKNwUAAAAABGyZqGidUfLfPWk73AuG0u_ylMa"
                    class="g-recaptcha"
                    required
                  ></re-captcha>
                </div>
              </div>
              <div class="form-group text-center mb-0">
                <button type="submit" class="btn btn-red btn-rounded px-5 py-0">
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-l2 d-lg-none">
        <button
          (click)="openContact = true"
          class="btn btn-red position-fixed lh-1"
          style="z-index: 20; bottom: 10%; right: 5%; width: fit-content"
        >
          ¡Contáctanos<br />ahora!
        </button>
      </div>
    </div>
  </div>
</div>

<div class="container my-lg-3 px-0 px-lg-3">
  <!-- Tabs -->
  <div class="row">
    <div class="col-lg-2">
      <div class="bg-gray1 pb-3 pb-lg-0" id="features-tab-container">
        <div
          class="nav flex-lg-column align-items-center align-items-lg-start"
          id="features-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <a
            class="nav-link active"
            id="features-image-tab"
            data-toggle="pill"
            data-target="#features-image"
            type="button"
            role="tab"
            aria-controls="features-image"
            aria-selected="true"
          >
            Imagen del<br />
            proyecto
          </a>
          <a
            class="nav-link"
            id="features-commons-tab"
            data-toggle="pill"
            data-target="#features-commons"
            type="button"
            role="tab"
            aria-controls="features-commons"
            aria-selected="false"
            >Zonas <br />
            Comunes</a
          >
          <a
            class="nav-link"
            id="features-advantages-tab"
            data-toggle="pill"
            data-target="#features-advantages"
            type="button"
            role="tab"
            aria-controls="features-advantages"
            aria-selected="false"
            >Ventajas <br />
            de la Zona
          </a>
          <a
            class="nav-link"
            id="features-plans-tab"
            data-toggle="pill"
            data-target="#features-plans"
            type="button"
            role="tab"
            aria-controls="features-plans"
            aria-selected="false"
            >Planos</a
          >
          <a
            class="nav-link"
            id="features-location-tab"
            data-toggle="pill"
            data-target="#features-location"
            type="button"
            role="tab"
            aria-controls="features-location"
            aria-selected="false"
            >Ubicación</a
          >
        </div>
      </div>
    </div>
    <div class="col-lg-10">
      <div class="tab-content" id="features-tabContent">
        <div
          class="tab-pane fade show active"
          id="features-image"
          role="tabpanel"
          aria-labelledby="features-image-tab"
        >
          <!-- IMAGEN Tab content  -->
          <div class="row align-items-center">
            <div class="col-lg-7">
              <div class="d-flex flex-column-reverse flex-lg-column">
                <div
                  *ngIf="images.length; else loadingData"
                  id="projectImagesControls"
                  class="carousel slide"
                  data-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div
                      class="carousel-item"
                      *ngFor="let img of images; index as i"
                      [class]="i == 0 ? 'active' : ''"
                    >
                      <img [src]="img.original" class="img-fluid w-100" />
                    </div>
                  </div>
                  <a
                    class="carousel-control-prev"
                    type="button"
                    data-target="#projectImagesControls"
                    data-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a
                    class="carousel-control-next"
                    type="button"
                    data-target="#projectImagesControls"
                    data-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>

                <!-- <div
                  class="bg-gray small text-secondary py-1"
                  id="projectImageFeatures"
                >
                  <div class="row align-items-center">
                    <div class="col-7">
                      <div class="row">
                        <div class="col pl-4 pr-0">
                          <div class="d-flex gap-1 justify-content-center">
                            <img
                              src="./assets/img/constructoras/icon-areaconstruida.svg"
                              alt=""
                            />
                            <div class="">
                              Área Construida
                              <h6 class="font-weight-bold small">
                                XX.XX m<sup>2</sup>
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex gap-1 justify-content-center">
                            <img
                              src="./assets/img/constructoras/icon-areaprivada.svg"
                              alt=""
                            />
                            <div class="">
                              Área Privada
                              <h6 class="font-weight-bold small">
                                XX.XX m<sup>2</sup>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <div class="row">
                        <div class="col-4">
                          <div class="d-flex gap-1">
                            <img
                              src="./assets/img/constructoras/icon-habitaciones.svg"
                              alt=""
                            />
                            <b>X</b>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="d-flex gap-1">
                            <img
                              src="./assets/img/constructoras/icon-banos.svg"
                              alt=""
                            />
                            <b>X</b>
                          </div>
                        </div>
                        <div class="col-4 pl-0 pr-4">
                          <div class="d-flex gap-1">
                            <img
                              src="./assets/img/constructoras/icon-estudios.svg"
                              alt=""
                            />
                            <b>X</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="col-lg-5">
              <div class="p-3 p-lg-0">
                <h5 class="text-uppercase text-red font-weight-bold">
                  Características {{ project.title }}
                </h5>
                <div class="" *ngIf="project.description; else loadingData">
                  <p>
                    {{ project.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="features-commons"
          role="tabpanel"
          aria-labelledby="features-commons-tab"
        >
          <!-- COMMONS Tab content  -->
          <div class="row align-items-center">
            <div class="col-lg-7">
              <div *ngIf="zone_files?.length > 0">
                <div
                  id="projectCommonsControls"
                  class="carousel slide"
                  data-ride="carousel"
                >
                  <div class="carousel-inner">
                    <ng-container *ngFor="let img of zone_files; index as i">
                      <div
                        class="carousel-item"
                        [class]="i == 0 ? 'active' : ''"
                      >
                        <img [src]="img.original" class="img-fluid w-100" />
                      </div>
                    </ng-container>
                  </div>
                  <a
                    class="carousel-control-prev"
                    type="button"
                    data-target="#projectCommonsControls"
                    data-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a
                    class="carousel-control-next"
                    type="button"
                    data-target="#projectCommonsControls"
                    data-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
              </div>
              <div *ngIf="zone_files?.length == 0" class="text-center font-italic">
                No hay imágenes en este momento
              </div>
            </div>
            <div class="col-lg-5">
              <div class="p-3 p-lg-0">
                <h5 class="text-uppercase text-red font-weight-bold ml-lg-4">
                  Zonas Comunes
                </h5>
                <div class="ml-3 ml-lg-0" *ngIf="project.options?.length > 0">
                  <ng-container *ngFor="let opt of project.options">
                    <ng-container *ngIf="opt.type_option == 'exterior'">
                      <div
                        class="mb-0"
                        *ngFor="
                          let characteristic of opt.options
                        "
                      >
                        <div
                          *ngIf="characteristic.config.type == 'counter' && characteristic.config.value"
                          class="d-flex align-items-center justify-content-start gap-1"
                        >
                          <img
                            src="{{ characteristic.image }}"
                            class="float-left"
                            width="15px"
                            onerror="this.src = '//cdn.vivienda.com/images/icons/otro.png'"
                          />
                          <p
                            class="text-regular text-overflow mb-0 ml-2 align-items-center"
                          >
                            {{  characteristic.name }}
                          </p>
                        </div>
                        <div
                          *ngIf="characteristic.config.type == 'multiple-list' && characteristic.config?.items?.length"
                          class="d-flex flex-nowrap gap-1"
                        >
                          <div class="img-multiple-list">
                            <img
                              src="{{ characteristic.image }}"
                              class="float-left"
                              width="15px"
                              onerror="this.src = '//cdn.vivienda.com/images/icons/otro.png'"
                            />
                          </div>
                          <div class="contain-item-multiple-list ml-2">
                            <p
                              class="mb-0"
                              *ngFor="
                                let item of characteristic.config.items;
                                index as i
                              "
                            >
                              {{ item.name }}
                            </p>
                          </div>
                        </div>

                        <div
                          *ngIf="characteristic.config.type == 'simple' && characteristic.config.value"
                          class="d-flex align-items-center justify-content-start gap-1"
                        >
                          <img
                            src="{{ characteristic.image }}"
                            class="float-left"
                            width="15px"
                            onerror="this.src = '//cdn.vivienda.com/images/icons/otro.png'"
                          />
                          <p
                            class="mb-0 text-regular text-overflow ml-2"
                            style="width: 80%"
                          >
                            {{ characteristic.name }}
                          </p>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="features-advantages"
          role="tabpanel"
          aria-labelledby="features-advantages-tab"
        >
          <!-- VENTAJAS DE LA ZONA Tab content  -->
          <div class="row align-items-center">
            <div class="col-lg-7">
              <div *ngIf="zone_files?.length > 0">
                <div
                  id="projectCommonsControls2"
                  class="carousel slide"
                  data-ride="carousel"
                >
                  <div class="carousel-inner">
                    <ng-container *ngFor="let img of zone_files; index as i">
                      <div
                        class="carousel-item"
                        [class]="i == 0 ? 'active' : ''"
                      >
                        <img [src]="img.original" class="img-fluid w-100" />
                      </div>
                    </ng-container>
                  </div>
                  <a
                    class="carousel-control-prev"
                    type="button"
                    data-target="#projectCommonsControls2"
                    data-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a
                    class="carousel-control-next"
                    type="button"
                    data-target="#projectCommonsControls2"
                    data-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
              </div>
              <div *ngIf="zone_files?.length == 0" class="text-center font-italic">
                No hay imágenes en este momento
              </div>
            </div>
            <div class="col-lg-5">
              <div class="p-3 p-lg-0">
                <h5 class="text-uppercase text-red font-weight-bold ml-lg-4">
                  Ventajas de la Zona
                </h5>
                <div class="ml-3 ml-lg-0">
                  <div
                    class="d-flex align-items-center gap-1"
                    *ngFor="let zone of project.nearby_sites"
                  >
                    <img
                      [src]="
                        './assets/img/constructoras/commons/' +
                        advantageZones[zone.slug] +
                        '.svg'
                      "
                      width="16"
                      height="16"
                    />
                    {{ zone.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="features-plans"
          role="tabpanel"
          aria-labelledby="features-plans-tab"
        >
          <!-- PLANOS tab content -->
          <div *ngIf="project?.blueprints?.length > 0">
          <div class="row">
            <div class="col-12">
              <div class="p-3 p-lg-0">
                <h5 class="text-uppercase text-red font-weight-bold">Planos</h5>
              </div>
            </div>
            <div
              class="col-lg-6 mb-3 mb-lg-0"
              *ngFor="let img of project.blueprints; let key = index"
            >
              <div class="p-3 p-lg-0">
                <img
                  [src]="img.image"
                  class="plano-img img-fluid w-100 cursor-pointer"
                  width="258"
                  (click)="openGallery(key)"
                />
                <div class="plano-areas small px-4 px-lg-0">
                  <p class="mb-0 small">
                    Área construida: {{ img.area_construida }} m<sup>2</sup>
                  </p>
                  <p class="mb-0 small">
                    Área A.A.: {{ img.area_aa }} m<sup>2</sup>
                  </p>
                  <p class="mb-0 small">
                    Área privada: {{ img.area_privada }} m<sup>2</sup>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <ngx-image-gallery
            id="imagesGallery"
            [images]="blueprints"
            [conf]="conf"
          ></ngx-image-gallery>
          </div>
          <div class="text-center font-italic py-5 my-lg-5" *ngIf="project?.blueprints?.length == 0">
            No hay planos en este momento
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="features-location"
          role="tabpanel"
          aria-labelledby="features-location-tab"
        >
          <!-- UBICACIÓN tab content -->
          <div class="row align-items-center flex-column-reverse flex-lg-row">
            <div class="col-lg-7">
              <div *ngIf="project.latitude && project.longitude">
                <a
                  href="https://www.google.com/maps/dir//{{
                    project.latitude
                  }},{{ project.longitude }}/"
                  class=""
                  target="_blank"
                >
                  <img
                    [src]="buildGoogleMapsImageUri()"
                    alt=""
                    class="img-fluid"
                    style="aspect-ratio: 2; object-fit: cover"
                  />
                </a>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="fit-content mx-auto mx-lg-0 py-3 py-lg-0">
                <div class="row mb-1 mb-lg-2">
                  <div class="col-auto pr-0">
                    <i class="fas fa-map-marker-alt"></i>
                  </div>
                  <div class="col">
                    <div><b> Sala de Ventas: </b></div>
                    <div>{{ project.address }}</div>
                    <div>Horario: {{ project.hours || "Lunes a Viernes" }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-auto pr-0">
                    <i class="fas fa-mobile-alt"></i>
                  </div>
                  <div class="col">
                    <div>
                      <b>Contacto</b>
                    </div>

                    <div class="" *ngIf="project.phones?.phone">
                      <a
                        href="tel:{{ project.phones.phone }}"
                        class="text-blue"
                      >
                        {{ project.phones.phone }}
                      </a>
                    </div>
                    <!-- <div class="mb-1">
                      <a
                        href="//{{ project.website || 'www.xxxxxxxxx.com' }}"
                        class="text-blue"
                        target="_blank"
                      >
                        {{ project.website || "www.xxxxxxxxx.com" }}
                      </a>
                    </div> -->

                    <div class="d-flex gap-1">
                      <a
                        *ngIf="project.phones?.phone"
                        href="tel:{{ project.phones?.phone }}"
                        class="btn px-2 py-1 shadow-sm bg-white text-secondary"
                      >
                        <i class="fas fa-phone-alt"></i>
                      </a>
                      <a
                        *ngIf="project.phones?.whatsapp"
                        href="//wa.me/{{ project.phones?.whatsapp }}"
                        class="btn px-2 py-1 shadow-sm bg-white text-success"
                        target="_blank"
                      >
                        <i class="fab fa-whatsapp"></i>
                      </a>
                      <!-- <a
                        href="mailto:"
                        class="btn px-2 py-1 shadow-sm bg-white text-secondary"
                      >
                        <i class="far fa-envelope"></i>
                      </a> -->

                      <a
                        href="https://www.waze.com/es/live-map/directions?to=ll.{{
                          project.latitude
                        }}%2C{{ project.longitude }}"
                        class="btn px-2 py-1 shadow-sm bg-white text-secondary"
                        target="_blank"
                        *ngIf="project.latitude && project.longitude"
                      >
                        <i class="fab fa-waze"></i>
                      </a>

                      <a
                        href="https://www.google.com/maps/dir//{{
                          project.latitude
                        }},{{ project.longitude }}/"
                        class="btn px-2 py-1 shadow-sm bg-white text-secondary"
                        target="_blank"
                        *ngIf="project.latitude && project.longitude"
                      >
                        <img
                          src="./assets/img/googlemaps.png"
                          alt=""
                          width="18"
                          height="18"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- UNIDADES DEL PROYECTO -->
  <section class="container mt-3">
    <div class="row align-items-center mb-3">
      <div class="col-7 col-lg-6">
        <h4 class="text-red text-uppercase d-none d-lg-block mb-0">
          <span class="font-weight-bold"> Unidades </span>
          <span class="font-weight-normal">del proyecto</span>
        </h4>
        <button
          class="btn btn-red btn-rounded d-block d-lg-none px-5"
          (click)="openf = !openf"
        >
          <h5 class="font-weight-bold mb-0 text-white">
            <i class="fas" [class]="openf ? 'fa-times' : 'fa-filter'"></i>
            Filtros
          </h5>
        </button>
      </div>
      <div class="col-5 col-lg-6">
        <div class="text-right text-red" *ngIf="project?.properties?.length">
          <b>{{ project?.properties?.length }}</b> resultados
        </div>
      </div>
    </div>
    <div class="row">
      <!-- filtros -->
      <div class="col-lg-3 pr-lg-0 py-lg-0">
        <div
          class="filtros bg-white rounded-3 mt-2 mt-lg-0"
          [class]="openf ? '' : 'd-none d-lg-block'"
        >
          <h5 class="text-red font-weight-bold d-none d-lg-block">
            Filtros
            <i class="fas" [class]="openf ? 'fa-times' : 'fa-filter'"></i>
          </h5>
          <div class="accordion" id="accordionFilters">
            <!-- filtro precio -->
            <div class="border-top border-red">
              <button
                class="btn btn-block py-2 d-flex justify-content-between align-items-center font-weight-bold"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Precio <i class="fas"></i>
              </button>

              <div
                id="collapseOne"
                class="collapse show"
                aria-labelledby="headingOne"
              >
                <div class="p-2">
                  <div class="row align-items-end">
                    <div class="col pr-0">
                      <div
                        class="small position-absolute mt-n3 ml-1 bg-white px-1"
                      >
                        <small>Minímo</small>
                      </div>
                      <input
                        type="text"
                        class="form-control w-100 m-0 rounded py-1 h-auto"
                        placeholder="Mínimo"
                        [(ngModel)]="price.max"
                      />
                    </div>
                    <div class="col pr-0">
                      <div
                        class="small position-absolute mt-n3 ml-1 bg-white px-1"
                      >
                        <small>Máximo</small>
                      </div>
                      <input
                        type="text"
                        class="form-control w-100 m-0 rounded py-1 h-auto"
                        placeholder="Máximo"
                        [(ngModel)]="price.min"
                      />
                    </div>
                    <div class="col-auto">
                      <a
                        class="btn btn-red text-white btn-sm"
                        (click)="filterProyecto()"
                      >
                        <i class="fas fa-search"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- filtro habitaciones -->
            <div class="border-top border-red">
              <button
                class="btn btn-block py-2 d-flex justify-content-between align-items-center font-weight-bold"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
              >
                Habitaciones <i class="fas"></i>
              </button>
              <div
                id="collapseTwo"
                class="collapse show"
                aria-labelledby="headingTwo"
              >
                <div class="p-2 d-flex justify-content-around small">
                  <div
                    class="form-check d-flex align-items-center mb-1 mx-0 px-0"
                    *ngFor="let check of number_rooms"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [value]="check.value"
                      [(ngModel)]="check.selected"
                      id="roomsCheck{{ check.value }}"
                      name="roomsCheck"
                    />
                    <label
                      class="form-check-label mr-1"
                      for="roomsCheck{{ check.value }}"
                    ></label>

                    <label
                      class="form-check-label"
                      for="roomsCheck{{ check.value }}"
                    >
                      {{ check.value }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- filtro baños -->
            <div class="border-top border-red">
              <button
                class="btn btn-block py-2 d-flex justify-content-between align-items-center font-weight-bold"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="true"
                aria-controls="collapseThree"
              >
                Baños <i class="fas"></i>
              </button>

              <div
                id="collapseThree"
                class="collapse show"
                aria-labelledby="headingThree"
              >
                <div class="p-2 d-flex justify-content-around small">
                  <div
                    class="form-check d-flex align-items-center mb-1 mx-0 px-0"
                    *ngFor="let check of number_bathrooms"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [value]="check.value"
                      [(ngModel)]="check.selected"
                      id="bathroomsCheck{{ check.value }}"
                      name="bathroomsCheck"
                    />
                    <label
                      class="form-check-label mr-1"
                      for="bathroomsCheck{{ check.value }}"
                    ></label>

                    <label
                      class="form-check-label"
                      for="bathroomsCheck{{ check.value }}"
                    >
                      {{ check.value }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- filtro parqueaderos -->
            <div class="border-top border-red">
              <button
                class="btn btn-block py-2 d-flex justify-content-between align-items-center font-weight-bold"
                type="button"
                data-toggle="collapse"
                data-target="#collapsFour"
                aria-expanded="true"
                aria-controls="collapseFour"
              >
                Parqueaderos <i class="fas"></i>
              </button>

              <div
                id="collapseFour"
                class="collapse show"
                aria-labelledby="headingFour"
              >
                <div class="p-2 d-flex justify-content-around small">
                  <div
                    class="form-check d-flex align-items-center mb-1 mx-0 px-0"
                    *ngFor="let check of number_parkings"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [value]="check.value"
                      [(ngModel)]="check.selected"
                      id="parkingCheck{{ check.value }}"
                      name="parkingCheck"
                    />
                    <label
                      class="form-check-label mr-1"
                      for="parkingCheck{{ check.value }}"
                    ></label>

                    <label
                      class="form-check-label"
                      for="parkingCheck{{ check.value }}"
                    >
                      {{ check.value }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- filtro área -->
            <div class="border-top border-red">
              <button
                class="btn btn-block py-2 d-flex justify-content-between align-items-center font-weight-bold"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="true"
                aria-controls="collapseFive"
              >
                Área <i class="fas"></i>
              </button>

              <div
                id="collapseFive"
                class="collapse show"
                aria-labelledby="headingFive"
              >
                <div class="p-2">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-6">
                        <div
                          class="small position-absolute mt-n3 ml-1 bg-white px-1"
                        >
                          <small>Desde</small>
                        </div>
                        <select
                          class="form-control w-100 rounded mt-0"
                          name="area-from"
                          [(ngModel)]="area.min"
                        >
                          <option value="" selected disabled>Desde</option>
                          <option
                            value="{{ area }}"
                            *ngFor="
                              let area of [60, 100, 200, 300, 400, 500, 1200]
                            "
                          >
                            {{ area }} m2 {{ areas == 1200 ? "+" : "" }}
                          </option>
                        </select>
                      </div>
                      <div class="col-6">
                        <div
                          class="small position-absolute mt-n3 ml-1 bg-white px-1"
                        >
                          <small>Hasta</small>
                        </div>
                        <select
                          class="form-control w-100 rounded mt-0"
                          name="area-to"
                          [(ngModel)]="area.max"
                        >
                          <option value="" selected disabled>Hasta</option>
                          <option
                            value="{{ area }}"
                            *ngFor="let area of [100, 200, 300, 400, 500, 1200]"
                          >
                            {{ area }} m2 {{ areas == 1200 ? "+" : "" }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-">
            <div class="d-flex align-items-center justify-content-center gap-2">
              <button
                class="btn border border-red btn-rounded p-1"
                (click)="getProyecto(); clearFilters()"
              >
                Borrar filtros
              </button>
              <button
                class="btn border border-red btn-red btn-rounded py-1 px-4"
                (click)="filterProyecto()"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>

        <!-- OLD FILTERS -->
        <!-- <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold"
              type="button"
              data-toggle="collapse"
              data-target="#collapseCero"
              aria-expanded="true"
              aria-controls="collapseCero"
            >
              Tipo de inmueble
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>

            <div
              id="collapseCero"
              class="collapse show border-top"
              aria-labelledby="headingCero"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <select
                  [(ngModel)]="type"
                  class="form-control w-100 rounded mt-0"
                  name="property-type"
                >
                  <option value="" selected disabled>Tipo de inmueble</option>
                  <option
                    *ngFor="let type of type_properties"
                    [value]="type.slug"
                  >
                    {{ type.type_property }}
                  </option>
                </select>
              </div>
            </div>
          </div> -->

        <!-- <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Estrato
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>

            <div
              id="collapseFive"
              class="collapse border-top"
              aria-labelledby="headingFive"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div
                  class="form-check d-flex align-items-center mb-1"
                  *ngFor="let check of number_strato"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [value]="check.value"
                    [(ngModel)]="check.selected"
                    id="estratoCheck{{ check.value }}"
                    name="estratoCheck"
                  />
                  <label
                    class="form-check-label mr-1"
                    for="estratoCheck{{ check.value }}"
                  ></label>

                  <label
                    class="form-check-label"
                    for="estratoCheck{{ check.value }}"
                  >
                    Estrato {{ check.value }}</label
                  >
                </div>
              </div>
            </div>
          </div> -->

        <!-- <div class="">
            <button
              class="btn border-top w-100 text-left font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseEight"
              aria-expanded="false"
              aria-controls="collapseEight"
            >
              Fecha de publicación
              <div class="float-right">
                <i class="fa" aria-hidden="true"></i>
              </div>
            </button>

            <div
              id="collapseEight"
              class="collapse border-top"
              aria-labelledby="headingEight"
              data-parent="#accordionFilters"
            >
              <div class="p-2">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="small text-secondary font-weight-bold">
                        Desde
                      </div>
                      <input
                        [(ngModel)]="publication_date.from"
                        type="date"
                        class="form-control w-100 rounded mt-0"
                        name="publish-date-from"
                      />
                    </div>
                    <div class="col-lg-6">
                      <div
                        class="small text-right text-secondary font-weight-bold"
                      >
                        Hasta
                      </div>
                      <input
                        [(ngModel)]="publication_date.to"
                        type="date"
                        class="form-control w-100 rounded mt-0"
                        name="publish-date-to"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
      </div>

      <div class="col-lg-9">
        <!-- content -->
        <!-- <ul
        class="nav justify-content-center border-bottom"
        id="tabFilter"
        role="tablist"
      >
        <li
          class=""
          role="presentation"
          *ngFor="let tab of tabFilter; let key = index"
        >
          <a
            class="nav-link text-red font-weight-bold {{
              key == 0 ? 'active' : ''
            }}"
            id="{{ tab.value }}-tab"
            data-toggle="tab"
            type="button"
            (click)="filterTabBy(tab.value)"
          >
            {{ tab.name }}
          </a>
        </li>
      </ul> -->
        <div *ngIf="!project.properties" class="py-5 text-center font-italic ">
          Buscando inmuembles...
        </div>
        <div *ngIf="project.properties?.length > 0" class="row">
          <div
            class="col-lg-4"
            *ngFor="let property of project.properties; let i = index"
          >
            <div class="card mb-3 overflow-hidden">
              <img [src]="property.image" class="card-img-top" alt="" />
              <div class="card-info-company">
                <div class="row align-items-center">
                  <div class="col-5">
                    <div class="card-logo text-center">
                      <img [src]="profile.image" alt="" class="img-fluid" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-body pt-1 pb-2">
                <h5 class="text-red font-weight-bold text-center mb-1">
                  {{ property.currency }} {{ property.amount }}
                </h5>
                <h6 class="text-center text-truncate text-capitalize mb-1">
                  {{ property.zone }}
                </h6>

                <div class="row justify-content-between small font-weight-bold">
                  <div class="col-12">
                    <div class="font-italic text-center">
                      {{ property.city }}
                    </div>
                  </div>
                </div>

                <!-- <div class="row justify-content-between small font-weight-bold">
                <div class="col-3 offset-9 px-0">
                  <div class="row">
                    <div class="col-2 px-0">
                      <img
                        src="./assets/img/constructoras/icon-shower.svg"
                        alt=""
                        width="15px"
                        class="img-fluid"
                      />
                    </div>
                    <div class="col-8 pl-0 pr-1 text-right">1 Baños</div>
                  </div>
                </div>
              </div> -->

                <!-- <div class="row justify-content-between small">
                <div class="col-9 pl-0">
                  <div class="font-italic">
                    <u>Apartamento en venta</u>
                  </div>
                </div>
                <div class="col-3 px-0">
                  <div class="row">
                    <div class="col-2 px-0">
                      <img
                        src="./assets/img/constructoras/icon-area.svg"
                        alt=""
                        width="15px"
                        class="img-fluid"
                      />
                    </div>
                    <div class="col-8 pl-0 pr-1 text-right font-weight-bold">
                      47 m<sup>2</sup>
                    </div>
                  </div>
                </div>
              </div> -->

                <div class="row mt-2">
                  <div class="dropup mb-0 w-100">
                    <button
                      type="button"
                      class="btn btn-blue btn-rounded w-100 font-italic"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-offset="0"
                    >
                      <small> CONTACTAR </small>
                    </button>
                    <div class="dropdown-menu shadow w-100 rounded-3 p-2">
                      <a
                        [href]="
                          project?.cellphones?.length > 0
                            ? 'tel:' + project?.cellphones[0]
                            : profile?.phone
                            ? 'tel:' + profile?.phone
                            : 'javascript:void(0)'
                        "
                        class="btn text-dark p-0 w-100"
                      >
                        <b><i class="fas fa-phone"></i> Teléfono:</b>
                        {{
                          project?.cellphones?.length > 0
                            ? project?.cellphones[0]
                            : profile?.phone
                            ? profile?.phone
                            : "No hay información de contacto"
                        }}
                      </a>
                    </div>
                  </div>

                  <a
                    class="btn btn-red btn-rounded w-100 font-italic mt-2"
                    href="./propiedad/{{ property.slug }}"
                  >
                    <small> VER INMUEBLE </small>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="my-2 text-center">
        <a
          class="btn btn-red-outline btn-rounded px-5 font-weight-bold font-italic"
        >
          <span class="px-4"> CARGAR MÁS RESULTADOS</span>
        </a>
      </div> -->

        <!-- end content -->
      </div>
    </div>
  </section>

  <!--
<section class="container related mt-5 mt-lg-3">
  <h3 class="text-center mb-3">Proyectos similares</h3>

  <div class="carouselrelated owl-carousel carousel-autoheight center-dots">
    <ng-container *ngFor="let project of projectsRelated; let i = index">
      <div class="card mb-3">
        <img
          src="./assets/img/constructoras/img-top-{{ i < 5 ? i : '3' }}.jpg"
          class="card-img-top"
          alt=""
        />
        <div class="card-info-company">
          <div class="row align-items-center">
            <div class="col-5">
              <div class="card-logo text-center">
                <img
                  src="./assets/img/constructoras/logo-3.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="card-stage text-center">
                <div class="btn-small btn-rounded bg-blue small text-white">
                  Sobre planos
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body pt-1 pb-2">
          <h5 class="text-blue font-weight-bold text-center mb-1">
            Austro de cuatro vientos
          </h5>

          <div class="row justify-content-between small font-weight-bold">
            <div class="col-9 pl-0">
              <div class="font-italic">Vereda, Bojacá - Chía</div>
            </div>
            <div class="col-3 px-0">
              <div class="row">
                <div class="col-2 px-0">
                  <img
                    src="./assets/img/constructoras/icon-bed.svg"
                    alt=""
                    width="15px"
                    class="img-fluid"
                  />
                </div>
                <div class="col-8 pl-0 pr-1 text-right">2 Apt</div>
              </div>
            </div>
          </div>

          <div class="row justify-content-between small">
            <div class="col-9 pl-0">
              <div class="font-italic">
                <u>Apartamentos en venta</u>
              </div>
            </div>
            <div class="col-3 px-0">
              <div class="row">
                <div class="col-2 px-0">
                  <img
                    src="./assets/img/constructoras/icon-area.svg"
                    alt=""
                    width="15px"
                    class="img-fluid"
                  />
                </div>
                <div class="col-8 pl-0 pr-1 text-right font-weight-bold">
                  47 m<sup>2</sup>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <button class="btn btn-blue btn-rounded w-100 font-italic">
              <small> CONTACTAR </small>
            </button>

            <a
              class="btn btn-red btn-rounded w-100 font-italic mt-2"
              href="/constructoras/{{ slug }}/{{ project }}/v2"
            >
              <small> VER PROYECTO </small>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section> -->
</div>

<ng-template #loadingData>
  <div class="text-center font-italic py-5">
    Cargando información...
  </div>

</ng-template>